export const ADD_LABELS = 'ADD_LABELS';
export const DELETE_LABELS = 'DELETE_LABELS';
export const SUGGEST_LABELS = 'SUGGEST_LABELS';
export const SHOW_EDIT_LABEL_DIALOG = 'SHOW_EDIT_LABEL_DIALOG';
export const CLOSE_EDIT_LABEL_DIALOG = 'CLOSE_EDIT_LABEL_DIALOG';
export const CLEAR_SUGGESTIONS = 'CLEAR_SUGGESTIONS';
export const CLEAR_ERROR_MESSAGES = 'CLEAR_ERROR_MESSAGES';
